import { CheckboxField } from '#/components/Form/CheckboxField';
import { InfoBox } from '#/components/InfoBox/InfoBox';
import { StyledNativeLinkWithRef } from '#/components/Link/StyledNativeLinkWithRef';
import { BodySmall } from '#/components/Text/BodySmall';
import { useI18n } from '#/i18n/hooks/useI18n';

export function ListingViewAtsApplicationFormConsentField({
  isEU,
  disabled,
}: {
  isEU: boolean;
  disabled?: boolean;
}) {
  const { i18n } = useI18n();

  return isEU ? (
    <CheckboxField
      name="consentAts"
      disabled={disabled}
      label={
        <BodySmall
          style={{ lineHeight: 1.375, paddingTop: 'calc(24px - 1em)' }}
        >
          {i18n(
            'By using the Idealist Application system, I consent to sharing my resume and other personal data with potential employers in accordance with Idealist’s {{linkPrivacyPolicy}}Privacy Policy{{/linkPrivacyPolicy}} and {{linkTermsOfService}}Terms of Service{{/linkTermsOfService}}. If you request us to share your Application Information with an Organization outside Europe, you explicitly consent to the transfer of your Application Information outside Europe.',
            {
              linkPrivacyPolicy: (
                <StyledNativeLinkWithRef
                  target="_blank"
                  href={i18n('/en/privacy-policy')}
                />
              ),
              linkTermsOfService: (
                <StyledNativeLinkWithRef
                  target="_blank"
                  href={i18n('/en/terms-of-service')}
                />
              ),
            },
          )}
        </BodySmall>
      }
    />
  ) : (
    <InfoBox $type="info" data-qa-id="consent-ats-text">
      <BodySmall style={{ lineHeight: 1.375 }}>
        {i18n(
          "I acknowledge that use of the Idealist Applicant Tracking System is subject to Idealist's {{linkPrivacyPolicy}}Privacy Policy{{/linkPrivacyPolicy}} and {{linkTermsOfService}}Terms of Service{{/linkTermsOfService}}.",
          {
            linkPrivacyPolicy: (
              <StyledNativeLinkWithRef
                target="_blank"
                href={i18n('/en/privacy-policy')}
              />
            ),
            linkTermsOfService: (
              <StyledNativeLinkWithRef
                target="_blank"
                href={i18n('/en/terms-of-service')}
              />
            ),
          },
        )}
      </BodySmall>
    </InfoBox>
  );
}
